import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Passenger } from './../../../models/passenger';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;
import * as moment from 'moment';

@Component({
  selector: 'app-passenger-view',
  templateUrl: './passenger-view.component.html',
  styleUrls: ['./passenger-view.component.css']
})
export class PassengerViewComponent implements OnInit {

  isAssistant: boolean;
  routeBase: string;
  PgNo: any;
  PgLen: any;

  passenger: Passenger;
  clients: any[];
  schools: any[];
  clientId: any;
  school: any;
  buses: any[];
  public subscriptionsData: any[];
  pnotify = undefined;
  option: any;
  map: any;
  markers: any[];
  markerBounds: any;
  adminStatus = true;
  firstNamesRegistrationNumbers: any[] = [];

  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.isAssistant = false;
    this.routeBase = 'passenger';
    this.passenger = new Passenger();
    this.route.params.subscribe(params => {
      this.PgNo = params['PgNo'];
      this.PgLen =  params['PgLen'];
      this.http.get(
        '/api/passenger/' + params['id']
      ).subscribe((data: any) => {
        const passenger = data.passenger;
        if (
          (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
          && this.authService.getUser().id !== passenger.School.clientId
        ) {
          this.router.navigate(['']);
        }
        this.passenger = passenger;
        this.clientId = passenger.School.clientId;
        this.initClientSelect();
        this.initSchoolSelect();
        this.initBusSelect();
        this.initFirstnamesRegistrationNumbers(passenger);
        this.subscriptionsData = [
          {
            id: 'Aller/Retour',
            text: 'Aller/Retour',
            selected: this.passenger.subscription == 'Aller/Retour' ? true : false
          },
          {
            id: 'Aller',
            text: 'Aller',
            selected: this.passenger.subscription == 'Aller' ? true : false
          },
          {
            id: 'Retour',
            text: 'Retour',
            selected: this.passenger.subscription == 'Retour' ? true : false
          },
        ];
      });
    });
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.adminStatus = this.authService.getUser().isRespAdmin;
    }
  }

  ngOnInit() {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant;
      });
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
      });
    }
  }

  initSchoolSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schools.forEach((school) => {
        if (school.id == this.passenger.schoolId) {
          this.school = school;
          this.initMap();
          this.map.fitBounds(this.markerBounds);
        }
      });
    });
  }

  initBusSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.clientId + '',
        schoolId: this.passenger.schoolId + ''
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
    });
  }

  subscriptionChanged(e: any) {
    this.passenger.subscription = e.value;
  }

  initMap() {
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 0, lng: 0 };
    this.option = {
      center: pos,
      zoom: 8,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), this.option);
    this.markerBounds = new google.maps.LatLngBounds();
    if (this.school) {
      this.markerBounds.extend(new google.maps.LatLng(pos));
      const schoolMarker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: 'assets/images/markers/school.png',
      });
    }
    this.markers = [];
    this.setMarker();
  }

  setMarker() {
    let pos = { lat: 0, lng: 0, };
    if (this.passenger.hasOwnProperty('id')) {
      pos = { lat: Number(this.passenger.lat), lng: Number(this.passenger.lng) };
      this.placeMarker(pos, false);
    } else {
      this.placeMarker(pos, true);
    }
  }

  placeMarker(pos, isInit = false) {
    if (this.markers[0]) {
      this.markers[0].setPosition(pos);
    } else {
      const passangerMarker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: 'assets/images/markers/passenger.png',
        draggable: false,
        zIndex: 100,
      });
      this.markers.push(passangerMarker);
    }
    this.passenger.lat = pos.lat;
    this.passenger.lng = pos.lng;
    if (!isInit &&
      (this.passenger.lat != null && this.passenger.lat !== 0) &&
      (this.passenger.lng != null && this.passenger.lng !== 0)) {
      this.passenger.isPositionValide = true;
      this.markerBounds.extend(new google.maps.LatLng({ lat: this.passenger.lat, lng: this.passenger.lng }));
    }
  }

  initFirstnamesRegistrationNumbers(passenger) {

    const firstNames = passenger.firstnames.split('/');
    const registrationNumbers = passenger.registrationNumbers.split('/');
    
    // Check if lengths match and create objects accordingly
    if (firstNames.length === registrationNumbers.length) {
        this.firstNamesRegistrationNumbers = firstNames.map((firstName, index) => {
            return { firstname: firstName.trim(), RegistrationNumber: registrationNumbers[index].trim() };
        });
    } else {
        this.firstNamesRegistrationNumbers = firstNames.map((firstName, index) => {
          return { firstname: firstName.trim(), RegistrationNumber: '-' };
        });
        //console.error('Lengths of first names and registration numbers do not match.');
    }
  }

  onSubmit(): void {
    this.http.put(
      '/api/passenger/' + this.passenger.id,
      { passenger: this.passenger }
    ).subscribe(
      (passenger: Passenger) => {
        this.passenger = passenger;
        this.router.navigate(['/' + this.routeBase + '/view', this.passenger.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-view/passenger-view.component.ts